import React from 'react'

const Loader = () => {
    return (
        <div style={styles.overlay}>
            <div style={styles.loaderWrapper}>
                <div style={styles.spinner}></div>
                <p style={styles.text}>Loading data...</p>
            </div>
        </div>
    )
}

const styles = {
    overlay: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(255,255,255,0.85)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    loaderWrapper: {
        textAlign: 'center'
    },
    spinner: {
        width: '60px',
        height: '60px',
        border: '6px solid #e5e7eb',
        borderTop: '6px solid #184d08',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    },
    text: {
        marginTop: '16px',
        fontSize: '14px',
        color: '#184d08',
        fontWeight: 500
    }
}

export default Loader;